'use strict';

export default {
  modalComponent: {
    action: {
      cancel: 'Annuler',
      submit: 'Confirmer',
    },
  },
};
